module.exports = __webpack_public_path__ + "img/icon_2.a06235d9.png";